import { usePreview } from 'shared/domains/documents';
import { AssistantButton } from './AssistantButton';
import { DocumentActionsDropdown } from './DocumentActionsDropdown';
import { EditButton } from './EditButton';
import { SandboxButton } from './SandboxButton';
import { Actions } from './styled';
export function DocumentActions(props) {
    const { documentId } = props;
    const { isComposed, isFreeText, isPdf, isDocx } = usePreview();
    const isAssistantSupported = isComposed || isFreeText || isPdf || isDocx;
    return (<Actions>
      <DocumentActionsDropdown documentId={documentId}/>
      <EditButton documentId={documentId}/>
      <SandboxButton />
      {isAssistantSupported && <AssistantButton />}
    </Actions>);
}
